document.addEventListener('DOMContentLoaded', function () {
    const charmContainers = document.querySelectorAll('[data-show-hide-charms]');

    if (charmContainers.length > 0) {
        charmContainers.forEach(charmContainer => {
            charmContainer.addEventListener('click', () => {
                const siblingList = charmContainer.nextElementSibling;
                const clearButtonId = `clear-charms-${charmContainer.id || 'random'}`;

                if (siblingList && siblingList.hasAttribute('data-charms-list')) {
                    const isHidden = siblingList.style.display === 'none' || getComputedStyle(siblingList).display === 'none';

                    siblingList.style.display = isHidden ? 'block' : 'none';

                    // Add or remove clear button based on visibility
                    if (isHidden) {
                        // Show charms, add clear button
                        let clearButton = charmContainer.querySelector(`#${clearButtonId}`);
                        if (!clearButton) {
                            clearButton = document.createElement('span');
                            clearButton.id = clearButtonId;
                            clearButton.textContent = ' clear';
                            clearButton.style.cursor = 'pointer';
                            clearButton.style.marginLeft = '10px';
                            clearButton.style.textDecoration = 'underline';
                            clearButton.style.fontSize = '0.8em'; // Match other small text
                            clearButton.style.verticalAlign = 'middle';
                            clearButton.style.color = '#555'; // Match other link/action color
                            
                            charmContainer.appendChild(clearButton);

                            clearButton.addEventListener('click', (e) => {
                                e.stopPropagation(); // Prevent the charmContainer click from toggling the list
                                e.preventDefault();

                                const productWrapper = charmContainer.closest('.product__submit__item');
                                if (!productWrapper) return;

                                const charmInputs = productWrapper.querySelectorAll('.charm__qty-input');
                                charmInputs.forEach(input => {
                                    input.value = 0;
                                    input.dispatchEvent(new Event('change', { bubbles: true }));
                                });
                                // Optionally hide the charm list after clearing
                                // siblingList.style.display = 'none';
                                // clearButton.remove();
                            });
                        }
                    } else {
                        // Hide charms, remove clear button
                        const clearButton = charmContainer.querySelector(`#${clearButtonId}`);
                        if (clearButton) {
                            clearButton.remove();
                        }

                        // Reset if hiding (existing logic)
                        const productWrapper = charmContainer.closest('.product__submit__item');
                        if (!productWrapper) return;

                        const charmInputs = productWrapper.querySelectorAll('.charm__qty-input');
                        charmInputs.forEach(input => {
                            input.value = 0;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        });

                        updateAddToCartPrice(productWrapper.querySelector('.charm__qty-input'));
                    }
                }
            });
        });
    }

    const charmQtyButtons = document.querySelectorAll('.charm__qty-btn');

    if (charmQtyButtons.length > 0) {
        charmQtyButtons.forEach(charmQtyButton => {
            charmQtyButton.addEventListener('click', (e) => {
                e.preventDefault();

                const container = charmQtyButton.closest('.charm__qty-container');
                const input = container.querySelector('.charm__qty-input');
                const currentValue = parseInt(input.value, 10) || 0;
                const max = parseInt(input.max, 10) || 9999;
                const min = parseInt(input.min, 10) || 0;

                const isIncrease = charmQtyButton.getAttribute('aria-label').toLowerCase().includes('increase');
                const isDecrease = charmQtyButton.getAttribute('aria-label').toLowerCase().includes('decrease');

                const productWrapper = input.closest('.product__submit__item');
                const allInputs = productWrapper.querySelectorAll('.charm__qty-input');

                let totalQty = 0;
                allInputs.forEach(i => {
                    totalQty += parseInt(i.value, 10) || 0;
                });

                if (isIncrease && totalQty < 10 && currentValue < max) {
                    input.value = currentValue + 1;
                } else if (isIncrease && totalQty >= 10) {
                    alert('You can only select up to 10 charms.');
                    return;
                } else if (isDecrease && currentValue > min) {
                    input.value = currentValue - 1;
                }

                input.dispatchEvent(new Event('change', { bubbles: true }));

                updateAddToCartPrice(input);
            });
        });
    }

    const charmQtyInputs = document.querySelectorAll('.charm__qty-input');

    if (charmQtyInputs.length > 0) {
        charmQtyInputs.forEach(input => {
            input.addEventListener('input', () => {
                validateAndUpdateInput(input);
            });

            input.addEventListener('change', () => {
                validateAndUpdateInput(input);
            });

            input.addEventListener('blur', () => {
                validateAndUpdateInput(input);
            });

            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            });
        });
    }

    function validateAndUpdateInput(input) {
        const min = parseInt(input.min, 10) || 0;
        const max = parseInt(input.max, 10) || 9999;
        let newValue = parseInt(input.value, 10);

        if (isNaN(newValue)) {
            newValue = 0;
        }

        const productWrapper = input.closest('.product__submit__item');
        if (!productWrapper) return;

        const allInputs = productWrapper.querySelectorAll('.charm__qty-input');

        let totalOtherQty = 0;
        allInputs.forEach(i => {
            if (i !== input) {
                totalOtherQty += parseInt(i.value, 10) || 0;
            }
        });

        const remaining = 10 - totalOtherQty;

        if (newValue > remaining) {
            alert('You can only select up to 10 charms total.');
        }

        newValue = Math.max(min, Math.min(newValue, Math.min(max, remaining)));

        input.value = newValue;

        updateAddToCartPrice(input);
    }

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        let placeholder = '';

        function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
            if (isNaN(number) || number == null) { return 0; }
            number = (number / 100.0).toFixed(precision);
            let parts = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
            let cents = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents;
        }

        if (format.indexOf('{{amount_no_decimals}}') !== -1) {
            value = formatWithDelimiters(cents, 0);
            placeholder = '{{amount_no_decimals}}';
        } else if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
            value = formatWithDelimiters(cents, 2, '.', ',');
            placeholder = '{{amount_with_comma_separator}}';
        } else if (format.indexOf('{{amount_with_apostrophe_separator}}') !== -1) {
            value = formatWithDelimiters(cents, 2, '\'', '.');
            placeholder = '{{amount_with_apostrophe_separator}}';
        } else {
            value = formatWithDelimiters(cents, 2);
            placeholder = '{{amount}}';
        }
        return format.replace(placeholder, value);
    }

    function updateAddToCartPrice(inputEl) {
        if (!inputEl) return;

        const productWrapper = inputEl.closest('.product__submit__item');
        if (!productWrapper) return;

        const allCharmInputs = productWrapper.querySelectorAll('.charm__qty-input');

        let totalCharmPrice = 0;

        allCharmInputs.forEach(input => {
            const qty = parseInt(input.value, 10) || 0;
            const priceEl = input.closest('.charm-option__content')?.querySelector('[data-price]');
            const unitPrice = priceEl ? parseInt(priceEl.getAttribute('data-price'), 10) : 0;

            totalCharmPrice += qty * unitPrice;
        });

        const addToCartBtn = productWrapper.querySelector('[data-add-to-cart]');
        if (!addToCartBtn) return;

        const basePrice = parseInt(addToCartBtn.getAttribute('data-base-price'), 10) || 0;
        const totalPrice = basePrice + totalCharmPrice;

        const priceDisplay = addToCartBtn.querySelector('[data-product-price]');
        if (priceDisplay) {
            priceDisplay.textContent = formatMoney(totalPrice, theme.moneyFormat);
        }
    }


    // Add selected charm quantities to cart
    function checkAndAddCharms(form) {
        const charmInputs = form.querySelectorAll('.charm__qty-input');
        const mainProductVariantInput = form.querySelector('input[name="id"]');
        const mainProductQuantityInput = form.querySelector('input[name="quantity"]');

        // Get all form data including engraving properties
        const formData = new FormData(form);
        const properties = {};
        
        // Extract properties from form data
        for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[') && value.trim() !== '') {
                const propName = key.replace('properties[', '').replace(']', '');
                properties[propName] = value;
            }
        }

        // Always include the main product variant
        const items = [];
        if (mainProductVariantInput && mainProductQuantityInput) {
            const mainItem = {
                id: parseInt(mainProductVariantInput.value, 10),
                quantity: parseInt(mainProductQuantityInput.value, 10) || 1
            };
            
            // Add properties if any exist
            if (Object.keys(properties).length > 0) {
                mainItem.properties = properties;
            }
            
            items.push(mainItem);
        }

        // Add selected charms to the items array
        charmInputs.forEach(input => {
            const qty = parseInt(input.value, 10);
            const variantId = input.dataset.charmId;

            if (qty > 0 && variantId) {
                items.push({
                    id: parseInt(variantId, 10),
                    quantity: qty
                });
            }
        });

        // Only proceed if there are items to add (at least the main product)
        if (items.length > 0) {
            // Disable the button to prevent double clicks
            const submitButton = form.querySelector('[data-add-to-cart]');
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.classList.add('loading');
            }

            // Use upcart's API if available, otherwise fallback to standard fetch
            if (typeof window.upcart !== 'undefined' && window.upcart.add) {
                // Use upcart's add method which should handle drawer opening
                window.upcart.add(items).then(response => {
                    console.log('Items added to cart via upcart:', response);

                    // ✅ Reset all charm inputs after successful addition
                    charmInputs.forEach(input => {
                        input.value = 0;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    });

                    // Re-enable the button
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('loading');
                    }

                    // Trigger the cart add event for other scripts (like gift selection)
                    document.dispatchEvent(new CustomEvent('theme:cart:add', {
                        bubbles: true,
                        detail: { items: response }
                    }));

                }).catch(err => {
                    console.error('Error adding items to cart via upcart:', err);
                    
                    // Re-enable the button on error
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('loading');
                    }
                });
            } else {
                // Fallback to standard fetch if upcart not available
                fetch(theme.routes.cart_add_url + '.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ items })
                })
                .then(res => res.json())
                .then(data => {
                    console.log('Items added to cart:', data);

                    // ✅ Reset all charm inputs after successful addition
                    charmInputs.forEach(input => {
                        input.value = 0;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    });

                    // Re-enable the button
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('loading');
                    }

                    // Refresh cart with upcart if available
                    if (typeof upcartRefreshCart === 'function') {
                        upcartRefreshCart();
                    }
                    
                    // Also try to open cart drawer manually if upcart has that method
                    if (typeof window.upcart !== 'undefined' && window.upcart.openCart) {
                        window.upcart.openCart();
                    }

                    // Trigger the cart add event for other scripts (like gift selection)
                    document.dispatchEvent(new CustomEvent('theme:cart:add', {
                        bubbles: true,
                        detail: { items: data }
                    }));
                    
                })
                .catch(err => {
                    console.error('Error adding items to cart:', err);
                    
                    // Re-enable the button on error
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('loading');
                    }
                });
            }
        } else {
             // This case should ideally not be reached if the main product is always included
             console.log('No items to add to cart.');
        }
    }

    document.addEventListener('click', function(event) {
        const addToCartButton = event.target.closest('[data-add-to-cart]');
        if (!addToCartButton) return;

        const form = addToCartButton.closest('form[action="/cart/add"]');
        if (!form) return;

        // Only intercept if there are charm inputs present
        const charmInputs = form.querySelectorAll('.charm__qty-input');
        if (charmInputs.length === 0) return; // Let the theme handle regular products

        // Check if any charms are selected
        const hasSelectedCharms = Array.from(charmInputs).some(input => parseInt(input.value, 10) > 0);
        
        // Only prevent default submission if charms are actually selected
        if (hasSelectedCharms) {
            event.preventDefault();
            checkAndAddCharms(form);
        }
        // If no charms selected, let the normal form submission handle it
    });
});
